export default {
    "0": "IVR",
}